import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { Button } from 'primeng/button'
import { map } from 'rxjs'

import { BaseLangSwitchDialog } from '../../../i18n/components/lang-switch-dialog/base'
import { LanguageService } from '../../../i18n/services/language.service'
import { DropdownSelectComponent } from '../inputs/dropdown-select/dropdown-select.component'

@Component({
  selector: 'app-lang-toggle',
  template: `
    <p-button
      [severity]="'secondary'"
      class="h--42"
      icon="pi pi-globe"
      (click)="menu.toggle($event)"
    ></p-button>

    @let currentLang = languageService.current();
    @let languageOptions = state.options() || [];
    <app-dropdown-select
      #menu
      [value]="currentLang ? [currentLang] : null"
      [options]="languageOptions"
      [appendTo]="'body'"
    ></app-dropdown-select>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Button, DropdownSelectComponent],
})
export class LangToggleComponent extends BaseLangSwitchDialog {
  protected readonly languageService = inject(LanguageService)

  protected override createLanguageOptionsStream() {
    return super.createLanguageOptionsStream().pipe(
      map((options) => {
        // Add commands to the select options
        return options.map((option) => {
          return { ...option, command: () => this.languageService.selectLanguage(option.value) }
        })
      }),
    )
  }
}
